<template>
    <div class="quanyi">
        <div class="qy-crad">
          <img :src="bjImg" class="dbg">
            <div class="mbcard" :style="whStyle">
                  <div class="mcitem">
                    <img :src="kaImg" class="mcitem1">
                    <div class="mcitem2" v-if="member">
                    <div style="display: flex;flex-direction: row;">
                        <div class="mcmytou">
                            <img v-if="member.headPortrait" :src="member.headPortrait" class="my-tou"/>
                            <div v-if="!member.headPortrait">
                                <img v-if="member.sex==0" src="./../../assets/nan.png" class="my-tou"/>
                                <img v-if="member.sex==1" src="./../../assets/nan.png" class="my-tou"/>
                                <img v-if="member.sex==2" src="./../../assets/nv.png" class="my-tou"/>
                            </div>
                        </div>
                        <div class="my-mbinfo">
                            <span style="font-size: 13px;margin-top: 8px;margin-bottom: 6px">{{member.memberName}}</span>
                            <span style="font-size: 13px;background-color: gainsboro;padding: 2px;">{{member.pmName==null?'PLUS: 未开通':member.pmName}}</span>
                        </div>
                    </div>
                        <span class="dqhb">
                            当前账号红包 0 元
                        </span>
                    </div>
                  </div>
                <span class="miaoshu">—— PLUS会员拥有多种特权 ——</span>
            </div>
        </div>
        <div class="tab-items" v-for="item in qys" v-if="qys.length>0">
            <template>
                <div>
                    <component :is="item.htmlContent" :item="item"></component>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import {getCookie, getDeptId, getDeptName} from "../../utils/auth";
    import Qydh from "./qydh/index";
    import TabBp from "./../common/bp/bp";

    export default {
        components: {
            Qydh,
            TabBp,
        },
        data() {
            return {
                deptId: '',
                deptName: '',
                qys: [],
                active:0,
                bjImg:'',
                kaImg:'',
                whStyle:'',
                member:{},
            };
        },
        async created() {
            document.title = getDeptName()
            let width = window.innerWidth*0.92
            let height = window.innerWidth*0.52
            this.whStyle='width:'+width+'px;height'+height+'px'
            this.deptId = getDeptId()
            this.token = getCookie('spmToken')
            this.getAds()
            this.getMember()
            this.getSpmGns()
        },
        methods: {
            async getAds() {
                let data = {
                    deptId: this.deptId
                }
                let res = await this.$get("/spm/getSpmQuanyiAds", data)
                if (res.bjImg){
                    this.bjImg=res.bjImg
                }
                if (res.kaImg){
                    this.kaImg=res.kaImg
                }
            },
            async getMember() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/spm/getMemberPlusInfo", data)
                this.member=res.member
            },

            async getSpmGns() {
                let data = {
                    deptId: this.deptId,
                    route: '/quanyi',
                }
                let res = await this.$get("/spm/getSpmGns", data)
                this.qys = res.list
            },
        },
    };
</script>

<style lang="scss" scoped>
    .quanyi {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-bottom: 49px;
    }
    .qy-crad{
        background-color: #F6F6F6;
        padding-bottom: 8px;
    }
    .dbg{
        width: 100%;
        height: 130px;
    }
    .mbcard{
        margin: auto;
        margin-top: -80px;
        align-items: center;
        display: flex;
        flex-direction: column;
    }
    .mbcard .miaoshu{
        margin-top: 20px;
        font-size: 13px;
        font-weight: bold;
    }

    .mcitem{
        width: 100%;
        height: 150px;
        border-radius: 10px;
    }
    .mcitem1{
        z-index: 1; /* z-index 控制层叠顺序，值越大越在上面 */
        width: 100%;
        height: 150px;
        border-radius: 10px;
    }
    .mcitem2{
        position: relative; /* 将 div1 设置为绝对定位 */
        top: -153px;
        left: 0;
        z-index: 2; /* z-index 控制层叠顺序，值越大越在上面 */
        width: 100%;
        height: 150px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        padding: 12px 0 0 15px;
    }
    .mcmytou{

    }
    .my-mbinfo {
        display: flex;
        flex-direction: column;
        margin-left: 8px;
    }
    .my-tou {
        width: 35px;
        height: 35px;
        border-radius: 50px;
    }
    .dqhb{
        position: absolute;
        bottom: 23%;
       font-size: 13px;
    }

    .selectTab /deep/ .van-tabs--line {
        height: 33px;
    }

    .selectTab /deep/ .van-tabs__wrap {
        height: 33px;
    }

    .selectTab /deep/ .van-tab--active {
        color: #323233;
        font-weight: 500;
        font-size: 14px;
        width: 100px;
    }

</style>
